export const getGeoCoordsY = (globalCoordY) => {
    return (2 * Math.atan(Math.exp(globalCoordY / 6378137)) - Math.PI / 2) / (Math.PI / 180)
}

export const getGeoCoordsX = (globalCoordX) => {
    return globalCoordX / (Math.PI / 180.0) / 6378137.0
}

export const nnTiles = [
    {
        "x": 315,
        "y": 160,
        "z": 9
    },
    {
        "x": 315,
        "y": 161,
        "z": 9
    },
    {
        "x": 317,
        "y": 155,
        "z": 9
    },
    {
        "x": 317,
        "y": 156,
        "z": 9
    },
    {
        "x": 317,
        "y": 157,
        "z": 9
    },
    // {
    //     "x": 316,
    //     "y": 157,
    //     "z": 9
    // },
    {
        "x": 158,
        "y": 79,
        "z": 8
    },
    {
        "x": 158,
        "y": 80,
        "z": 8
    },
    {
        "x": 316,
        "y": 162,
        "z": 9
    },
    {
        "x": 317,
        "y": 162,
        "z": 9
    },
    {
        "x": 319,
        "y": 154,
        "z": 9
    },
    {
        "x": 319,
        "y": 155,
        "z": 9
    },
    {
        "x": 318,
        "y": 155,
        "z": 9
    },
    {
        "x": 159,
        "y": 78,
        "z": 8
    },
    {
        "x": 159,
        "y": 79,
        "z": 8
    },
    {
        "x": 159,
        "y": 80,
        "z": 8
    },
    {
        "x": 318,
        "y": 162,
        "z": 9
    },
    {
        "x": 319,
        "y": 162,
        "z": 9
    },
    {
        "x": 319,
        "y": 163,
        "z": 9
    },
    {
        "x": 160,
        "y": 77,
        "z": 8
    },
    {
        "x": 160,
        "y": 78,
        "z": 8
    },
    {
        "x": 160,
        "y": 79,
        "z": 8
    },
    {
        "x": 160,
        "y": 80,
        "z": 8
    },
    {
        "x": 320,
        "y": 162,
        "z": 9
    },
    {
        "x": 640,
        "y": 326,
        "z": 10
    },
    {
        "x": 161,
        "y": 77,
        "z": 8
    },
    {
        "x": 322,
        "y": 156,
        "z": 9
    }
]

export const largeNNTiles = [
    {
        "x": 79,
        "y": 38,
        "z": 7
    },
    {
        "x": 80,
        "y": 38,
        "z": 7
    },
    {
        "x": 80,
        "y": 39,
        "z": 7
    },
    {
        "x": 80,
        "y": 40,
        "z": 7
    },
    {
        "x": 79,
        "y": 40,
        "z": 7
    },
    {
        "x": 157,
        "y": 80,
        "z": 8
    },
    {
        "x": 158,
        "y": 78,
        "z": 8
    },
    {
        "x": 159,
        "y": 78,
        "z": 8
    },
    {
        "x": 158,
        "y": 79,
        "z": 8
    },
    // {
    //     "x": 318,
    //     "y": 158,
    //     "z": 9
    // },
    {
        "x": 636,
        "y": 316,
        "z": 10
    },
    {
        "x": 637,
        "y": 316,
        "z": 10
    },
    {
        "x": 636,
        "y": 317,
        "z": 10
    },
    {
        "x": 637,
        "y": 317,
        "z": 10
    },
    {
        "x": 319,
        "y": 158,
        "z": 9
    },
    {
        "x": 319,
        "y": 159,
        "z": 9
    },
    {
        "x": 318,
        "y": 159,
        "z": 9
    },
]